import React from "react";
import omit from "@/utils/omit";
import { IconProps } from "../interface";

const IconAdArrow = React.forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <svg
    width="8"
    height="8"
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...omit(props, ["className"])}
    ref={ref}
    className="yfm-icon yfm-icon-ad-arrow"
  >
    <path
      d="M4.00162 7.48128C3.9521 7.48085 3.90385 7.46551 3.86317 7.43726L0.205081 5.01801C0.0314197 4.90357 -0.047008 4.60026 0.0290189 4.34017C0.105046 4.08008 0.308317 3.96244 0.480378 4.07688L4.00162 6.4049L7.52286 4.07688C7.69652 3.96244 7.89899 4.07688 7.97502 4.33937C8.05105 4.60186 7.97502 4.89957 7.79976 5.01801L4.13847 7.43726C4.09762 7.46516 4.04948 7.48046 4.00002 7.48128H4.00162ZM4.00162 3.44866C3.95223 3.44817 3.90407 3.43314 3.86317 3.40544L0.205081 0.985388C0.0314197 0.870947 -0.047008 0.56764 0.0290189 0.307548C0.105046 0.0474567 0.308317 -0.0693845 0.480378 0.0450558L4.00162 2.37148L7.52286 0.0442555C7.69652 -0.0701848 7.89899 0.0442555 7.97502 0.307548C8.05105 0.570841 7.97502 0.867746 7.79976 0.985388L4.13847 3.40464C4.09779 3.43289 4.04954 3.44823 4.00002 3.44866H4.00162Z"
      fill="#17215C"
    />
  </svg>
));

IconAdArrow.displayName = "IconAdArrow";

export default IconAdArrow;
